import { render } from "./AIRRChart.vue?vue&type=template&id=f7c5a2bc&ts=true"
import script from "./AIRRChart.vue?vue&type=script&lang=ts"
export * from "./AIRRChart.vue?vue&type=script&lang=ts"

import "./AIRRChart.vue?vue&type=style&index=0&id=f7c5a2bc&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__